import { IngredientModal } from "./IngredientModal";
export default IngredientModal;
